// extracted by mini-css-extract-plugin
export default {"navbar":"Layout_navbar__Drla6","dashboard":"Layout_dashboard__tGW7N","mainContent":"Layout_mainContent__6XeFz","noScroll":"Layout_noScroll__SSaOm","footer":"Layout_footer__s+SIt"};